import {SODeleteRealization} from '../../core/realization/so-delete-realization';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRealization extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRealization;
}